define(function(require, exports, module) {
    'use strict';
    var user = require('user');
    var url = require('util/url.util');
    var config = require('config');

    module.exports = {
        storePromoCode: function() {
            var promoCode = url.getLocationParameterByName('promocode');

            if (promoCode) {
                user.set('promoCode', promoCode);
            }
        },

        insertPromoCode: function() {
            var promoCode = user.get('promoCode');
            var $selector = this.$('[name="promoCode"]');

            if (promoCode) {
                return $selector.val(promoCode);
            }

            if (config.get('dynamicTags.DTAG_CONTINUE_REGISTER_URL')) {
                $selector.attr('type', 'hidden');
            }
        }
    };
});
